<template>
  <v-layout column fluid>
    <v-flex>
      <HeaderBar>
        <v-icon slot="icon">settings</v-icon>
        Settings
      </HeaderBar>
    </v-flex>

    <v-flex>
      <div>
        <router-link :to="{ name: 'settingsCallin' }">Call-in Bonus</router-link>
      </div>
      <div>
        <router-link :to="{ name: 'settingsHolidays' }">Holidays</router-link>
      </div>
      <div>
        <router-link :to="{ name: 'settingsBulletins' }">Bulletin Board</router-link>
      </div>
      <div v-if="user.bohOrHigher">
        <hr class="my-4" />
        <h3>Debug and testing</h3>
        <p>Careful. Options and settings here are intended for use on staging only</p>
        <div>
          <v-btn color="error" @click="confirmSunset = true">Run shift sunsetting</v-btn>
        </div>
      </div>
    </v-flex>
  <v-dialog v-model="confirmSunset" maxWidth="300">
    <v-card>
      <v-card-title>
        <h1>Warning!</h1>
      </v-card-title>
      <v-card-text>
        Sunset all shifts with sunset time set before right now?
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn flat :loading="sunsetPending" :disabled="sunsetPending" @click="confirmSunset = false">
          Nevermind
        </v-btn>
        <v-btn color="error" :loading="sunsetPending" :disabled="sunsetPending" @click="runSunset">
          Yes!
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
  </v-layout>
</template>

<script>
import { mapState } from 'vuex'
import settingApi from '@/api/setting.js'

export default {
  components: {
  },
  computed: {
    ...mapState('userAuth', [
      'user',
    ]),
    exampleComputed: function () {
      return this.example
    },
  },
  created () {
  },
  watch: {
  },
  data: function () {
    return {
      confirmSunset: false,
      sunsetPending: false,
    }
  },
  methods: {
    runSunset () {
      this.sunsetPending = true
      settingApi.debugSunset().then((r) => {
      }).finally(() => {
        this.sunsetPending = false
        this.confirmSunset = false
      })
    },
  },
}
</script>

<style scoped>
</style>
